import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ILandingPage } from 'src/app/model/http/landing.model';

@Component({
  selector: 'app-landing-content',
  templateUrl: './landing-content.component.html',
  styleUrls: ['./landing-content.component.scss']
})
export class LandingContentComponent implements AfterViewInit {
  @Input() data: ILandingPage = {
    id: 0,
    route: '',
    url: '',
    content: '',
    published_at: '',
    created_at: '',
    updated_at: '',
    hasSubtitle: false,
    hasPrecontent: false,
    isQuestion: false
  };
  anchors: string[] = [];
  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: any,
  ) { }

  ngAfterViewInit(): void {
    this.anchors = this.router.url.split('#');
    this.anchors.forEach((anchor) => {
      this.document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    });
  }

}
